import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { useApiData } from 'lib/api';
import { PathParticipantSteps } from 'components/paths';
import { ProfilePathsPathProgress, ProfilePathsPathSummary } from '.';

import type { GetUserPathsRes } from 'shared-types/responses';

interface Props {
  isUserPage?: boolean;
  pathId: number;
}

const ProfilePathsPath = ({ isUserPage, pathId }: Props) => {
  const {
    pageState: { user },
    user: loggedInUser
  } = useReduxState();

  const { loading, data } = useApiData<GetUserPathsRes>({
    url: `/admin/users/${user.id}/paths?id=${pathId}`,
    onlyIf: Boolean(user)
  });

  return (
    <div className="path">
      <div className="summary">
        <ProfilePathsPathSummary
          isUserPage={isUserPage}
          loading={loading}
          path={data?.paths[0]}
          targetUser={user}
        />
      </div>

      <div className="main">
        <div className="progress">
          <ProfilePathsPathProgress
            isUserPage={isUserPage}
            loading={loading}
            path={data?.paths[0]}
          />
        </div>

        <div className="steps">
          <PathParticipantSteps
            isUserPage={isUserPage}
            steps={data?.paths[0]?.steps}
            progressData={data?.paths[0]?.progressData}
            deadlines={data?.paths[0]?.deadlines}
            loading={loading}
            userSettings={{}}
            targetUser={user}
          />
        </div>
      </div>

      <style jsx>{`
        .path {
          display: flex;
          flex-direction: column;
          gap: 30px 25px;
        }
        .steps {
          margin-top: 30px;
        }
        @media (min-width: ${breakpoints.large}px) {
          .path {
            flex-direction: row;
          }
          .summary {
            flex-shrink: 0;
            width: 360px;
          }
          .main {
            flex-grow: 1;
            min-width: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default ProfilePathsPath;
